import * as React from 'react'
import { IconsModel } from '../types/iconsModel'

const SvgBalcon = (
	{
		color,
		width = 28,
		height = 35
	}: IconsModel
) => (
	<svg
		id="balcon_svg__FULL_VECTO_SEUL"
		xmlns="http://www.w3.org/2000/svg"
		viewBox="0 0 425.2 425.2"
		width={width}
		height={height}
	>
		<defs>
			<style>
				{
					`.prestation_cls_fill_none{fill:none;stroke:${color};stroke-miterlimit:40;stroke-width:10px}`
				}
			</style>
		</defs>
		<circle className="prestation_cls_fill_none" cx={297.64} cy={106.3} r={21.26} />
		<path
			className="prestation_cls_fill_none"
			d="M255.12 106.3V63.78H106.3v127.56M287.01 318.9H106.3M318.9 233.86v85.04H106.3M255.12 127.56 212.6 212.6M180.71 63.78V212.6M265.75 170.08l31.89 42.52h21.26l-21.26-63.78M106.3 212.6h170.08M106.3 361.42c0-11.74 9.52-21.26 21.26-21.26M127.56 340.16h148.82"
		/>
	</svg>
)
export default SvgBalcon
